export const BASE_PATH = `/animal-nuisance`;
export const RoutesList = {
  BEFORE_YOU_START: BASE_PATH,
  REPORT_TYPE: BASE_PATH + '/report-type',
  CALL_US: BASE_PATH + '/call-us',
  ISSUE_TYPE: BASE_PATH + '/issue-type',
  DESCRIBE_THE_ISSUE: BASE_PATH + '/describe-the-issue',
  IS_RECURRING_ISSUE: BASE_PATH + '/is-recurring-issue',
  UPLOAD_PHOTO: BASE_PATH + '/upload-photo',
  ISSUE_LOCATION: BASE_PATH + '/issue-location',
  CONFIRMATION_EMAIL: BASE_PATH + '/confirmation-email',
  CONTACT_ABOUT_THE_ISSUE: BASE_PATH + '/contact-about-the-issue',
  YOUR_DETAILS: BASE_PATH + '/your-details',
  CONFIRMATION: BASE_PATH + '/confirmation',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: '/500',
  REPORT_TO_TFL: '/report-to-tfl',
};

export const steps = [
  {
    label: 'Issue details',
    urlPaths: [
      RoutesList.REPORT_TYPE,
      RoutesList.ISSUE_TYPE,
      RoutesList.DESCRIBE_THE_ISSUE,
      RoutesList.IS_RECURRING_ISSUE,
    ],
  },
  {
    label: 'Photos',
    urlPaths: [RoutesList.UPLOAD_PHOTO],
  },
  {
    label: 'Location',
    urlPaths: [RoutesList.ISSUE_LOCATION],
  },
  {
    label: 'Your details',
    urlPaths: [
      RoutesList.CONFIRMATION_EMAIL,
      RoutesList.CONTACT_ABOUT_THE_ISSUE,
      RoutesList.YOUR_DETAILS,
    ],
  },
];
